module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/triangle-orange@2x-48c3f168db4762e1bf2f926fb3803d3c.png";